import WithBootedClient from '../../lib/WithBootedClient';
import RESTClient, {IArrayRestResponse} from '../RESTClient';
import IJwt from '../../models/IJwt';
import TaskClient from '../TaskClient';
import {IOpenCloseStoreMetadata} from '../../models/tasks/metadatas/IOpenCloseStoreMetadata';
import UserClient from '../UserClient';
import {ITask} from '../../models/tasks/ITask';
import {IUser} from '../../models/users/IUser';
import {ITaskFilter} from '../../models/tasks/ITaskFilter';
import StoreClient from '../StoreClient';
import {IStore} from '../../models/tasks/IStore';
import moment from 'moment';
import OpenCloseStoreOffline from '../offline-tasks/OpenCloseStoreOfflineClient';
import Secrets from '@yumi/secrets';

interface IConfig {
  baseURL: string;
}

class OpenCloseClient extends RESTClient implements WithBootedClient {
  constructor(config: IConfig) {
    super({baseURL: config.baseURL});
  }

  async boot() {}

  validate(action: 'OPEN' | 'CLOSE'): boolean {
    // define star hour to open store
    const openStart = moment(`${moment().format('YYYY-MM-DD')} 05:00:00`);
    // define end hour to open store
    const openEnd = moment(`${moment().format('YYYY-MM-DD')} 19:00:00`);

    // if action is close i can do it
    if (action === 'CLOSE') {
      return true;
      // if action is open i can do it only if it is between starthour and endhour
    } else if (action === 'OPEN' && moment().isBetween(openStart, openEnd)) {
      return true;
      // if action is open i can do it only if it is between starthour and endhour
    } else {
      return false;
    }
  }
  async createTask(data: IOpenCloseStoreMetadata, jwt: IJwt): Promise<void> {
    OpenCloseStoreOffline.cleanPushDB();
    return TaskClient.createTask(data, jwt, 'OPENCLOSESTORE');
  }

  async createReport(data: any, operation?: string): Promise<any> {
    return await OpenCloseStoreOffline.saveData(data, operation);
  }

  async getTask(
    filter: ITaskFilter
  ): Promise<ITask<IOpenCloseStoreMetadata> | null> {
    filter.taskType = 'OPENCLOSESTORE';
    try {
      const result: IArrayRestResponse<ITask<IOpenCloseStoreMetadata>> =
        await UserClient.getTasks(filter);
      if (!result.data[0]) return null;
      return result.data[0];
    } catch (error) {
      return null;
    }
  }

  async getTasksByType(
    filter: ITaskFilter
  ): Promise<IArrayRestResponse<ITask<IOpenCloseStoreMetadata>>> {
    filter.taskType = 'OPENCLOSESTORE';
    return TaskClient.getByType(filter);
  }

  async getPartnerUsers(): Promise<Array<IUser>> {
    return TaskClient.getPartnerUsers('openclosestore.read');
  }

  async getStore(country: string, storeId: string): Promise<IStore> {
      const result: IArrayRestResponse<IStore> = await StoreClient.getStores(
        country,
        storeId
      );
      return result.data[0];

  }
}

export default new OpenCloseClient({
  baseURL: Secrets.REACT_APP_API_ENDPOINT!
});
